module.exports = __webpack_public_path__ + "img/primary_5x4_z18.f8318bc6.svg";